import AddNewPage from './AddNewPage';
import ControlPageEngine from './ControlPageEngine';
import ControlPageEntry from './ControlPageEntry';
import getYupSchemaForPageEngine from './getYupSchemaForPageEngine';
import { ControlConfig } from '../controlConfig';
import PagePlaceholder from './ControlPagePlaceholder';

export default {
  getDefaultValue: () => ({}),
  getLatestSchema: () => {
    throw Error('Not implemented');
  },
  Engine: ControlPageEngine,
  Entry: ControlPageEntry,
  Add: AddNewPage,
  yupSchemaEngine: getYupSchemaForPageEngine,
  yupSchemaEntry: () => ({}),
  translator: {},
  Placeholder: PagePlaceholder,
  previewCardHeight: '35px'
} as ControlConfig;
